import React from 'react';
import { Outlet } from 'react-router-dom';
import MerchantAuth from '../pages/Merchant/MerchantAuth/MerchantAuth';

export const ProtectedRouterMerchant = () => {
  const token = localStorage.getItem('token');
  return token ? <Outlet /> : <MerchantAuth />;
};
